/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { SeasonNodeType } from './SeasonNodeType';
import {
    SeasonNodeTypeFromJSON,
    SeasonNodeTypeFromJSONTyped,
    SeasonNodeTypeToJSON,
    SeasonNodeTypeToJSONTyped,
} from './SeasonNodeType';

/**
 * 
 * @export
 * @interface SeasonTier
 */
export interface SeasonTier {
    /**
     * Position in the pass (1–15). Sequential — cannot claim tier N without passing N-1.
     * @type {number}
     * @memberof SeasonTier
     */
    tierNumber: number;
    /**
     * Cumulative pass XP required to unlock this tier (not a delta from previous tier).
     * @type {number}
     * @memberof SeasonTier
     */
    xpRequired: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeasonTier
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof SeasonTier
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {SeasonNodeType}
     * @memberof SeasonTier
     */
    nodeType: SeasonNodeType;
    /**
     * 
     * @type {string}
     * @memberof SeasonTier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SeasonTier
     */
    description?: string;
}



/**
 * Check if a given object implements the SeasonTier interface.
 */
export function instanceOfSeasonTier(value: object): value is SeasonTier {
    if (!('tierNumber' in value) || value['tierNumber'] === undefined) return false;
    if (!('xpRequired' in value) || value['xpRequired'] === undefined) return false;
    if (!('nodeType' in value) || value['nodeType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SeasonTierFromJSON(json: any): SeasonTier {
    return SeasonTierFromJSONTyped(json, false);
}

export function SeasonTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonTier {
    if (json == null) {
        return json;
    }
    return {
        
        'tierNumber': json['tierNumber'],
        'xpRequired': json['xpRequired'],
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'nodeType': SeasonNodeTypeFromJSON(json['nodeType']),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function SeasonTierToJSON(json: any): SeasonTier {
    return SeasonTierToJSONTyped(json, false);
}

export function SeasonTierToJSONTyped(value?: SeasonTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tierNumber': value['tierNumber'],
        'xpRequired': value['xpRequired'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'nodeType': SeasonNodeTypeToJSON(value['nodeType']),
        'name': value['name'],
        'description': value['description'],
    };
}

